export const computeJobAdsLocationRequest = (locations: string[]): (string | undefined)[] =>
  locations.map(location => location.split("::_").shift())
